import React from 'react';
import styles from './Header.module.css';
import logoIcon from '../assets/icon/logo_icon.svg';
import logoText from '../assets/icon/logo_text.svg';
import icDownload from '../assets/icon/ic_download.svg';
import {useScreenDetector} from "../hooks/useScreenDetector";


const Header: React.FC = () => {
    const {isMobile} = useScreenDetector();

    return (
        <div className={styles.header}>
            <nav className={styles.nav}>
                <div className={styles.logoContainer} onClick={() => {
                    window.open('https://satoshiapp.xyz', '_blank');
                }}>
                    <img
                        src={logoIcon}
                        className={styles.logo}
                    />
                    <img
                        src={logoText}
                        className={styles.logoText}
                    />
                </div>
                <div className={styles.navActions}>
                    <button className={styles.appButton}
                            onClick={() => {
                                window.open('https://satoshiapp.xyz/en/download-app', '_blank');
                            }}
                    >
                        <img className={styles.appButtonIcon} src={icDownload}/>
                        {!isMobile && (
                            <span className={styles.appButtonText}>Satoshi App</span>
                        )}
                    </button>

                </div>
            </nav>
        </div>
    );
};

export default Header;